// Shared Lists — type catalog driving icon, label, and which columns appear.
// Backend type strings (must match models.py SHARED_LIST_TYPES):
//   simple_notes, basic_checklist, checklist_total,
//   snag_list, shopping_list, client_revisions, contractor_checklist

import {
  FiEdit3, FiCheckSquare, FiList, FiAlertOctagon,
  FiShoppingCart, FiRefreshCw, FiBriefcase,
} from 'react-icons/fi';

export const SHARED_LIST_TYPES = [
  {
    value: 'simple_notes',
    label: 'Simple Notes',
    description: 'A clean notes list — just titles and optional descriptions.',
    icon: FiEdit3,
    color: '#0F0F10',
    columns: { check: false, description: true, qty: false, money: false, location: false, company: false, status: false },
  },
  {
    value: 'basic_checklist',
    label: 'Basic Checklist',
    description: 'Checkboxes with text. Quick to-do or punch list.',
    icon: FiCheckSquare,
    color: '#0073EA',
    columns: { check: true, description: true, qty: false, money: false, location: false, company: false, status: false },
  },
  {
    value: 'checklist_total',
    label: 'Checklist with Totals',
    description: 'Checkboxes with qty x unit price. Auto-calculates totals.',
    icon: FiList,
    color: '#1DBF73',
    columns: { check: true, description: false, qty: true, money: true, location: false, company: false, status: false },
  },
  {
    value: 'snag_list',
    label: 'Snag List',
    description: 'Location, responsible company, status. For site defects.',
    icon: FiAlertOctagon,
    color: '#E24B5B',
    columns: { check: false, description: true, qty: false, money: false, location: true, company: true, status: true },
  },
  {
    value: 'shopping_list',
    label: 'Shopping List',
    description: 'Items with quantity and prices. Great for procurement.',
    icon: FiShoppingCart,
    color: '#F4A340',
    columns: { check: true, description: false, qty: true, money: true, location: false, company: false, status: false },
  },
  {
    value: 'client_revisions',
    label: 'Client Revisions',
    description: 'Track requested changes from the client with status.',
    icon: FiRefreshCw,
    color: '#A358DF',
    columns: { check: false, description: true, qty: false, money: false, location: false, company: false, status: true },
  },
  {
    value: 'contractor_checklist',
    label: 'Contractor Checklist',
    description: 'Assign tasks to contractors with status tracking.',
    icon: FiBriefcase,
    color: '#00875A',
    columns: { check: true, description: true, qty: false, money: false, location: false, company: true, status: true },
  },
];

export const getTypeMeta = (value) =>
  SHARED_LIST_TYPES.find((t) => t.value === value) || SHARED_LIST_TYPES[0];

export const STATUS_OPTIONS = [
  { value: 'open', label: 'Open', color: '#F4A340' },
  { value: 'in_progress', label: 'In Progress', color: '#0073EA' },
  { value: 'done', label: 'Done', color: '#1DBF73' },
  { value: 'wont_fix', label: "Won't Fix", color: '#9CA3AF' },
];

export const getStatusMeta = (value) =>
  STATUS_OPTIONS.find((s) => s.value === value) || STATUS_OPTIONS[0];
